module.exports = __webpack_public_path__ + "static/media/8OLA22.02a0040f.jpg";